import { WalletDrawerTranslations } from ".";

export const WALLET_DRAWER_FR_FR: WalletDrawerTranslations = {
	title: "Votre Portefeuille Zig",
	totalBalance: "Solde Total",
	transactions: "Transactions",
	unifiedWithdrawTransfer: "Retrait et Transfert",
	ticketPayment: "Paiement de Billets",
	transferBetweenPlaces: "Transfert entre Lieux",
};
